export default __webpack_public_path__ + "static/media/Patrick1_Hero_1920x1080_ZW.ef7ead09.jpg";